import React from 'react';
import ReactModal from 'react-modal';

import { batchResultLines, batchResultTitle } from '../../../../config/guestOrdering';
import ErrorReference from '../../../../components/UI/ErrorReference';
import { toDisplayError } from '../../../../utils/userError';

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
    padding: 0,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    maxHeight: '95vh',
    overflow: 'auto',
  },
  overlay: {
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
};

// "2 orders placed" (the existing green success look) or "Some orders weren't placed"
// (the existing red error look) after sending one order per person.
const GuestOrdersResult = ({ result, onClose }) => {
  const title = batchResultTitle(result);
  const lines = batchResultLines(result);
  // What support needs when an order wasn't placed: the code, when, and the server's id.
  const failure = !result.allPlaced && result.failureCode
    ? toDisplayError({
      title,
      referenceCode: result.failureCode,
      at: result.failureAt,
      serverId: result.failureServerId,
    })
    : null;
  return (
    <ReactModal
      isOpen={true}
      style={customStyles}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={result.allPlaced ? 'dialog' : 'alertdialog'}
      aria={{ labelledby: 'guest-orders-result-title', describedby: 'guest-orders-result-message' }}
      contentLabel={title}
    >
      <div
        className={`lb-geral ${result.allPlaced ? 'lb-placed_' : 'lb-error_'} mfp-bg-login white-popup-block singup zoom-anim-dialog guest-orders-result`}
      >
        <div className="lb-padrao-singup6 mfp-content-login modal-content">
          <button
            onClick={onClose}
            type="button"
            className="bt-close mfp-close lb-fechar fa fa-times"
            aria-label="Close"
          />
          <div className="check-mark">
            {result.allPlaced ? (
              <span className="fa fa-check-circle lt-success-tick" aria-hidden="true" />
            ) : (
              <img alt="" src={require('../../../../img/error-mark.png')} />
            )}
          </div>
          <div className="lb-content">
            <span className="order" id="guest-orders-result-message">
              <strong id="guest-orders-result-title">{title}</strong>
              {lines.map((line, index) => (
                <span className="guest-orders-result-line" key={index}>
                  {line}
                </span>
              ))}
              {failure && <ErrorReference error={failure} showContact onContactSupport={onClose} />}
            </span>
            <a onClick={onClose} className="bt" role="button" tabIndex={0}>
              {result.allPlaced ? 'Got it' : 'Close'}
            </a>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default GuestOrdersResult;



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/GuestRecipient/GuestOrdersResult.js